import React, { Component } from 'react'

export default class FooterOptions extends Component {
    constructor(props){
        super(props)
    }

    render() {
        return (
            <div className = { this.props.className ? `footeroptions ${this.props.className}` : "footeroptions"}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FooterOptions.js